import React, { useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  useStore,
  FunctionField,
  DateField,
} from 'react-admin'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import {
  PostFilterButtonBanner,
  PostFilterFormBanner,
} from 'src/components/pages/marketing/banner/BannerFilter'

export const BannerList = (props) => {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return (
      permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
    )
  }

  const allFilters = [
    { source: 'short_name', name: 'ra.field.short_name' },
    { source: 'flow', name: 'ra.field.flow' },
    { source: 'banner_type_id__in', name: 'ra.field.banner_type' },
    { source: 'business_unit_id__in', name: 'ra.field.business_unit' },
    { source: 'work_unit_id__in', name: 'ra.field.work_unit' },
    { source: 'datetime', name: 'ra.field.date' },
  ]

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.banner')}>
        <List
          {...props}
          component='div'
          actions={
            <ListViewTopToolbar
              hasCreate={permissions?.hasCreate}
              listFilters={allFilters}
              FilterButtonComponent={PostFilterButtonBanner}
              FilterFormComponent={PostFilterFormBanner}
            />
          }
        >
          <Datagrid rowClick='show' setSort={onClickSort} isLoading={isLoading}>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='short_name' label={translate('ra.field.short_name')} />
            <TextField source='flow' label={translate('ra.field.flow')} />
            <TextField source='banner_type_relation.long_name' label={translate('ra.field.banner_type')} />
            <FunctionField
              label={translate('ra.field.work_unit')}
              render={(record) => {
                return record?.work_unit_short_names?.join(', ') || '-'
              }}
            />
            <FunctionField
              label={translate('ra.field.business_unit')}
              render={(record) => {
                return record?.business_unit?.join(', ') || '-'
              }}
            />

            <DateField label={translate('ra.field.datetime_from')} source='datetime_from' />
            <DateField label={translate('ra.field.datetime_to')} source='datetime_to' />
            {hasPermissions() && (
              <ListViewActionsButtons
                label={translate('ra.action.actions')}
                fieldsName={['short_name']}
                genderElement='masculine'
                clone={true}
                disableRevision
              />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
